module.exports = __webpack_public_path__ + "img/approval_top_up.6f748ea0.svg";